import { Role, StaffSection } from 'models'

export const languages = [
  { value: 'pt_BR', label: 'Português' },
  { value: 'en_US', label: 'English' },
  { value: 'es_UY', label: 'Español' }
]

export const roles = [
  { value: Role.ROOT, label: 'Root' },
  { value: Role.MANAGER, label: 'Gerente' },
  { value: Role.FINANCE, label: 'Financeiro' },
  { value: Role.SUPPORT, label: 'Suporte' },
  { value: Role.SALES, label: 'Vendas' },
  { value: Role.LOGISTICS, label: 'Logística' }
]

export const sections = [
  { value: StaffSection.IS, label: 'IS' },
  { value: StaffSection.CS, label: 'CS' }
]
